import { useBreakpoints, useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Avatar, Text } from '../../forms'
import { Box } from '../../widgets'
import { Teams } from './'
import { randomInt } from '@10000/common'

export const InviteTeamLeader = ({ active, id, organisationId }) => {
  const request = useRequest('tenant')
  const { users } = useView('tenant')
  const { push } = useStack()
  const { mobile } = useBreakpoints()

  useShell({ active, mode: 'navigate narrow' })
  useBackground().set(mobile => ({ active, fade: false, ...onboardBackground(true, mobile) }))

  const inviteTeamLeader = ({ email, avatar }) => {
    if(email) {
      const userIndex = users.findIndex(user => user.email === email)
      if(userIndex > -1) {
        return request('teamUpdated', { id, leaders: [users[userIndex].id] }).then(() => push(Teams, { props: { organisationId } }))
      } else {
        return request('userAdded', { teamId: id, email, avatar }).then(() => push(Teams, { props: { organisationId } }))
      }
    }
  }

  return <InputScreen
    onSubmit={inviteTeamLeader}
    formValues={{ avatar: randomInt(6) }}
    footerButton="Send"
    title="Invite new Team Leader"
    description="Enter the email of the person who will set up the team"
  >
    <Box column gap={24} fullWidth>
      <Avatar name="avatar" size={mobile ? 'medium' : 'large'} />
      <Text title="Send an email invite" name="email" type="email" />
    </Box>
  </InputScreen>
}